import {
  CollectionActions,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformUserInfo } from './user-info.transformers';
import { UserInfoCollection } from './user-info.types';

export function userInfoReducer(
  state = {},
  action: CollectionActions<UserInfoCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (action.payload.type === 'userInfo') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<UserInfoCollection>(
          state,
          transformIntoDocuments([result], transformUserInfo),
          order,
          ref,
        );
      }
      return state;
    default:
      return state;
  }
}
